const localizations = {
  date: {
    default: "%-d %B %Y",
  },
  time: {
    default: "%H:%M",
  },
};

const translations = {
  address: "Alamat",
  addressDelivery: "Alamat Pengiriman",
  age: "Usia",
  ageText: "Tahun",
  birthdate: "Tanggal Lahir",
  cancel: "Batal",
  class: "Kelas",
  done: "Selesai",
  education: "Pendidikan",
  email: "Email",
  female: "Perempuan",
  gender: "Jenis Kelamin",
  hospital: "Rumah Sakit",
  intendedFor: "Ditujukan untuk siapa sesi konsultasi ini?",
  male: "Laki-Laki",
  myDependency: "Tertanggung",
  dependencyNotAvailable: "Daftar peserta tidak tersedia",
  next: "Selanjutnya",
  others: "Lainnya",
  phoneNumber: "Nomor Telepon",
  cellphoneNumber: "Nomor Ponsel",
  practiceLicense: "SIP",
  lifepackSubscriptionIdWithNumber: "Nomor Pesanan: {{no}}",
  lifepackSubscriptionId: "Nomor Pesanan",
  prescriptionNoAlt: "Nomor Resep",
  prescriptionDate: "Tanggal Resep Dibuat",
  redeemDate: "Tanggal Pembelian",
  prescriptionDelivery: "Status Pesanan",
  prescriptionStatusDelivery: "Status Pesanan: {{status}}",
  prescriptionDeliveryStatuses: {
    in_review: "Resep sedang ditinjau",
    prescription_approved: "Resep disetujui apoteker",
    prescriprion_adjusted: "Resep diterima dengan perubahan",
    order_cancelled: "Pesanan dibatalkan",
    prescription_rejected: "Resep ditolak apoteker",
    pending_address: "Menantikan alamat",
    payment_order: "Menunggu pembayaran",
    waiting_for_payment: "Menunggu pembayaran",
    payment_successful: "Pembayaran berhasil",
    payment_expired: "Tempo pembayaran kadaluarsa",
    payment_failed: "Pembayaran tidak berhasil",
    order_processed: "Pesanan dipersiapkan",
    waiting_for_pickup: "Menunggu dijemput",
    picked_up: "Pesanan sudah dijemput",
    on_delivery: "Pesanan dalam pengantaran",
    delivered: "Pesanan diterima",
    delivery_failed: "Pengantaran gagal",
    active: "Aktif",
    inactive: "Tidak aktif",
  },
  prescriptionDeliveryDetail: "Informasi Pengiriman",
  prescriptionDeliveryDetailRecipientName: "Nama Penerima",
  prescriptionDeliveryView: "Detail Status",
  prescriptionDownload: "Unduh Resep",
  prescriptionClaim: "Proses Klaim",
  prescriptionPatient: "Nama Pasien",
  prescriptionPayment: "Informasi Pembayaran",
  orderInfo: "Informasi Pesanan",
  prescriptionPaymentMedicine: "Total Biaya Obat",
  prescriptionPaymentDelivery: "Total Biaya Pengiriman",
  prescriptionPaymentTotal: "Total Harga",
  prescriptionPaymentDownload: "Unduh Invoice",
  prescriptionRejectReason: "Alasan ditolak: {{reason}}",
  prescriptionView: "Detail Pesanan",
  prescriptionRedeem: "Tebus Resep",
  prescriptionDetail: "Lihat Resep",
  prescriptionOn: "{{date}}, Pukul {{time}}",
  previous: "Sebelumnya",
  registrationCertificate: "STR",
  select: "Pilih",
  sessionOn: "Sesi pada {{date}}",
  skip: "Lewati",
  status: "Status",
  defaultStatusDelivery: "Status Pesanan: Resep Ditebus",
  consultationFor: "Pemeriksaan Untuk",
  day: "hari",
  week: "minggu",
  month: "bulan",
};

export default {
  localizations,
  translations,
};
